import { Router } from "@reach/router";
import { Spin, Col, Row } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

import Layout from "../component/general/layout";
import AccountDelete from "../page/accountdelete";
import Administration from "../page/administration";
import Download from "../page/download";
import Multivers from "../page/multivers";
import Order from "../page/order";
import Privacy from "../page/privacy";
import Report from "../page/report";
import Select from "../page/select";
import SignIn from "../page/signin";
import Terms from "../page/terms";
import User from "../page/user";
import { useStore } from "../store";

const styles = {
  container: {
    height: "100vh",
  },
};

const Loading = () => (
  <Row justify="center" align="middle" style={styles.container}>
    <Col>
      <Spin size="large" />
    </Col>
  </Row>
);

const AppRouter = () => {
  const { auth } = useStore();
  if (!auth.isLoaded) {
    return <Loading />;
  }
  if (!auth.isSignedIn) {
    return (
      <Router>
        <SignIn path="/signin" default />
        <Download path="/download" />
        <Download path="/invitation/:invitationCode" />
        <Privacy path="/privacy" />
        <Terms path="/terms" />
        <AccountDelete path="/account/delete" />
      </Router>
    );
  }
  return (
    <Router>
      <Layout path="/">
        <Select path="/" />
        <Administration path=":administrationId">
          <Order path="/order" />
          <User path="/user" />
          <Multivers path="/multivers" />
          <Report path="/report" />
          <Report path="/report/:reportId" />
        </Administration>
      </Layout>
      <Download path="/download" />
      <Download path="/invitation/:invitationCode" />
      <Privacy path="/privacy" />
      <Terms path="/terms" />
    </Router>
  );
};
export default observer(AppRouter);
